export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <h3 className="text-4xl font-bold mb-4 text-white tracking-wide" style={{ fontFamily: '"Times New Roman", serif', letterSpacing: '0.1em' }}>
              EMA
            </h3>
            <p className="text-gray-400 mb-6">
              Expert-Comptable inscrit à l'ordre des experts comptables en France et en Tunisie. 
              Votre partenaire de confiance pour l'externalisation comptable.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors cursor-pointer">
                <i className="ri-twitter-fill"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Nos Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Tenue de comptabilité</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Établissement des comptes</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Déclarations fiscales</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Paie et social</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Reporting et analyse</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Liens Rapides</h4>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">Nos Services</a></li>
              <li><a href="#avantages" className="hover:text-white transition-colors cursor-pointer">Nos Avantages</a></li>
              <li><a href="#processus" className="hover:text-white transition-colors cursor-pointer">Notre Processus</a></li>
              <li><a href="#temoignages" className="hover:text-white transition-colors cursor-pointer">Témoignages</a></li>
              <li><a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer">Made with Readdy</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact</h4>
            <div className="space-y-3 text-gray-400">
              <div className="flex items-center">
                <i className="ri-map-pin-line mr-3"></i>
                <span>La Marsa, Tunisie</span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line mr-3"></i>
                <span>+33 6 15 46 78 15</span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line mr-3"></i>
                <span>+216 29 50 70 50</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line mr-3"></i>
                <span>contact@scmggroup.com</span>
              </div>
              <div className="flex items-center">
                <i className="ri-time-line mr-3"></i>
                <span>Lun-Sam: 8h-18h</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 EMA Expert-Comptable. Tous droits réservés.
            </p>
            <div className="flex space-x-6 text-sm text-gray-400">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">Mentions légales</a>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">Politique de confidentialité</a>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">CGV</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}